import sweetalertconfig from "@/configs/sweetalert.js";
import { isNullOrUndefined } from "util";
//import moment from "moment";
const moment = require('moment-timezone'); 
import _ from "lodash";

const newLocal = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
	name: "funcUtil",
	data: function () {
		return {
			SingleLineSpecialChars: "",
			MultiLineSpecialChars: ""
		}
	},
	methods: {

		_getGUID() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},

		// Input: an array of objects and one of the keys from the objects as string 
		// Action: forms a string of the values, each separated by a comma
		// Return: a string
		_stringifyArrayByKey(array, key) {
			let string = '';
			array.forEach((object, index) => {
				string = (index === 0) ? object[key] : string + ', ' + object[key]
			});
			return string;
		},

		// Input: an array of objects and one of the keys from the objects as string 
		// Action: groups by the array into multiple arrays by the key
		// Return: an object
		_groupArrayByKey(array, key) {
			return array.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		},

		_filterGrid(GridData, SearchData) {
			let filteredData = GridData.filter(obj => {
				return Object.keys(obj).some(k => {
					if (k !== "uid") {
						if (obj[k] != null) {
							return (
								obj[k].toString().toLowerCase().indexOf(SearchData.toLowerCase()) !== -1
							);
						}
					}
				});

			});
			return filteredData;
		},

		_filterGridByColumn(GridData, ColumnName, SearchData) {
			let filteredData = GridData.filter(function (e) {
				return e[ColumnName].toLowerCase().indexOf(SearchData.toLowerCase()) !== -1
			});
			return filteredData;
		},

		_addClassToColumn(e, gridId, fieldName, className) {
			const columnIndex = $(`#${gridId}`).find(`.k-grid-header [data-field=${fieldName}]`).index();
			const rows = e.sender.tbody.children();
			for (let j = 0; j < rows.length; j++) {
				let row = $(rows[j]);
				let cell = row.children().eq(columnIndex);
				cell.addClass(className);
			}
		},

		_addClassToStatusColumn(e, gridId) {
			let columnIndex = "";
			if (gridId == "issuanceGrid" || gridId == "issuanceReportGrid" || gridId == "TransferGrid" || gridId == "TransferReportGrid" || gridId == "buyoutProgramDetailGrid" || gridId == "vestingGrid" || gridId == "vestingReportGrid") {
				columnIndex = $("#" + gridId).find(".k-grid-header [data-field=WorkflowStatus]").index();
			}
			else {
				columnIndex = $("#" + gridId).find(".k-grid-header [data-field=Status]").index();
			}

			const rows = e.sender.tbody.children();
			let colorcolumn = "";
			for (let j = 0; j < rows.length; j++) {
				let row = $(rows[j]);
				let cell = row.children().eq(columnIndex);
				let dataItem = e.sender.dataItem(row);
				if (gridId == "issuanceGrid" || gridId == "issuanceReportGrid" || gridId == "TransferGrid" || gridId == "TransferReportGrid" || gridId == "buyoutProgramDetailGrid" || gridId == "vestingGrid" || gridId == "vestingReportGrid") {
					colorcolumn = dataItem.get("WorkflowStatus");
				}
				else {
					colorcolumn = dataItem.get("Status");
				}

				let cssClass = getStatusClass(colorcolumn);
				cell.html("<div style='text-align: center'><div class='chip " + cssClass + "'>" + colorcolumn + "</div></div>");
				//cell.addClass(getStatusClass(colorcolumn));
			}

			function getStatusClass(status) {
				switch (status) {
					case "Pending":
						return "status-in-process";
					case "Processing":
						return "status-processing";
					case "Error":
						return "status-error";
					case "Approved":
						return "status-completed";
					case "In Progress":
						return "status-in-process";
					case "Completed":
						return "status-completed";
					case "Not Started":
						return "status-not-started";
					case "Correction Pending":
						return "status-correction-pending";
					case "Correction Approved":
						return "status-correction-approved";
					default:
						return "status-disabled"
				}
			}
		},

		_setDropdownFilter(array) {
			return (array != undefined && array.length >= 10) ? 'contains' : undefined;
		},

		//sweet alert custom methods:
		// Usage example:
		// _AlertPopup("test","success") //success alert
		// _AlertPopup("test","info") //info alert
		// _AlertPopup("test","warning") //warning alert
		// _AlertPopup("test","error") //error alert
		_AlertPopup(Message, Type) {
			this.$swal({ type: Type, text: Message });
		},
		copyText: function(){
			let dummy = $('.copy_text').val();
			$('.copy_text').select();
			document.execCommand('copy');
	// sweet alert
			Swal.fire({
				position: 'center',
				icon: 'success',
				title: 'token Copied',
				text: dummy,
				showConfirmButton: false,
				timer: 1500
			});
		},
		_MessagePopup: function (Message) {

			//default config which will get passed if key is null or the wrong key is passed to this function
			//let config = sweetalertconfig["DEFAULT"];
			let config = sweetalertconfig["DEFAULT"];
			return this.$swal({
				title: "EUM Token",
				text: Message,
				button: "Close",
			  });
		},
		_MessagePopupWCopy: function (Message) {

			//default config which will get passed if key is null or the wrong key is passed to this function
			let config = sweetalertconfig["DEFAULT"];
			return this.$swal({
				title: "EUM Token",
				text: Message,
				button: "Close",
			  });
		},

		// Usage example:	
		// Key is an optional parameter and it can accept the values like ("APPROVE" or "DELETE" or "SAVE") and it is not case sensitive
		// Key can be configured in the sweetalertconfig.js file

		// this._ConfirmationPopup("Confirmation Mesage","APPROVE").then((result) => {
		//     if (result.value) {
		//         // confirm button clicked
		// 	   }
		// });	

		// See Documentation at: https://sweetalert2.github.io/#configuration
		// Input Types at: https://sweetalert2.github.io/#input-types
		_SweetAlertTextPopup: function(type, title, confirmBtnText, cancelBtnText, text){
			return this.$swal({
				title: title,
				text: text,
				type: type,
				confirmButtonText: confirmBtnText,
				cancelButtonText: cancelBtnText,
				showCancelButton: true,
				showCloseButton: true,
				allowOutsideClick: false
			})
		},

		_SweetAlertHTMLPopup: function(type, title, confirmBtnText, cancelBtnText, html){
			return this.$swal({
				title: title,
				html: html,
				type: type,
				confirmButtonText: confirmBtnText,
				cancelButtonText: cancelBtnText,
				showCancelButton: true,
				showCloseButton: true,
				allowOutsideClick: false
			})
		},
		
		_ConfirmationPopup: function (Message, Key) {

			//default config which will get passed if key is null or the wrong key is passed to this function
			let config = sweetalertconfig["DEFAULT"];

			//get the config from sweetalertconfig.js based on the key value
			if (!isNullOrUndefined(Key)) {
				let KeyString = Key.toString().toUpperCase();
				if (!isNullOrUndefined(sweetalertconfig[KeyString])) {
					config = sweetalertconfig[KeyString];
				}
			}
			// console.log("key",key);
			// console.log(config);
			return this.$swal({
				title: config.title,
				text: Message,
				type: 'warning',
				confirmButtonText: config.confirmButtonText,
				cancelButtonText: config.cancelButtonText,
				showCancelButton: true,
				showCloseButton: true,
				allowOutsideClick: false
			})
		},

		//This function Can hide/show grid columns based on configs
		//Params :gridId (string) , columnConfig:  {"ColumnName":"Hide/Show"} 
		//Sample Call : this._displayGridColumns("Grid1",{"Column1Name":"hide","Column2Name":"show"})
		_displayGridColumns(gridId, columnConfig) {

			let grid = $("#" + gridId).data("kendoGrid");

			_.forEach(columnConfig, function (value, key) {

				switch (value) {
					case "hide":
						grid.hideColumn(key)
						break;
					case "show":
						grid.showColumn(key)
						break;
					default:
						break;
				}
			})

		},
		//This function returns the next incremenatla ID for the key in the collection
		//Params :collection ([{'ID':'1'},{'ID':'2'}]) key='ID' returns 3 

		_getIncrementalID(collection, key) {

			let lastElement = !collection ? null : _.maxBy(collection, function (obj) 
				{ 
					if(!!obj && !!key && Object.keys(obj).includes(key))
						return obj[key];
					else
						return null; 
				});
			
			// If lastElement is truthy (not null, undefined), convert it's key'd value to number and increment....else 1
			return !!lastElement ? (+lastElement[key] + 1) : 1;
		},
		GetBatchGUIDArray(batchGUID) {
			if (!isNullOrUndefined(batchGUID) && !batchGUID == "") {
				return batchGUID.split(",").map(Number);
			} else {
				return []
			}
		},
		ShowAutoCompleteListOnFocus(kendoAutoCompleteId) {
			$("#" + kendoAutoCompleteId).bind('click', function (e) {
				let autocomplete = $("#" + kendoAutoCompleteId).data("kendoAutoComplete");
				if (autocomplete.value() == "") {
					autocomplete.search("");
				}
			});
		},
		filterGridRowByColumn(grid, columnName, valueToMatch, valueOperator, isChecked) {

			grid.dataSource.filter({})
			grid.dataSource.filter({ field: columnName, operator: valueOperator, value: valueToMatch });
			// if (isChecked) {
			// 	this.gridFilter.filters.push({ field: columnName, operator: valueOperator, value: valueToMatch });
			// 	grid.dataSource.filter(this.gridFilter);
			// } else {
			// 	this.gridFilter.filters.splice(this.gridFilter.filters.findIndex(f => f.value == valueToMatch), 1);
			// 	grid.dataSource.filter(this.gridFilter);
			// }
		},


		// this is for individual column background based on the column name.
		//  Columns.push({"column":"InvestmentTitle","row":i});->for individual cells

		// this is for changing background for "Validation" column if the row contains Valid/Invalid data.
		// Columns.push({"column":"Validation","row":i});

		ValidateImportData(gridId, columns) {
			let dataItem = $("#" + gridId).data("kendoGrid").dataSource.data();
			columns.forEach(elem => {
				let colIndex = getcolIndex(gridId, elem.column);
				if (elem.column == "Validation") {
					let row = $("#" + gridId).data("kendoGrid").tbody.find("tr[data-uid=" + dataItem[elem.row].uid + "]");
					let cell = row.children().eq(colIndex);
					if (columns.length == 1) {
						cell.addClass("valid-cell")
						cell.text("Valid");
					}
					else {
						cell.addClass("invalid-cell")
						cell.text("InValid Input");
					}
				} else {
					let row = $("#" + gridId).data("kendoGrid").tbody.find("tr[data-uid=" + dataItem[elem.row].uid + "]");
					let cell = row.children().eq(colIndex);
					cell.addClass("invalid-cell");
				}
			})
			function getcolIndex(GridID, colName) {
				return $("#" + GridID).data("kendoGrid").thead.find("th[data-field=" + colName + "]").attr('data-index')
			}
		},
		_getBatchGUIDUpdateConfig(listName) {
			return {
				list: listName,
				columns: {
					Id: {
						dataName: "Id",
						type: "number"
					},
					BatchGUID: {
						dataName: "BatchGUID",
						type: "string"
					}
				}
			};
		},
		//Accepts a string and returns a string with first letter of each word to upper
		_firstLetterToUpper(inputWord) {
			if (typeof (inputWord) == 'string') {

				let strArray = inputWord.split(' ');
				let outputArray = [];
				for (let x = 0; x < strArray.length; x++) {
					outputArray.push(strArray[x].charAt(0).toUpperCase() + strArray[x].slice(1));
				}
				return outputArray.join(' ');
			} else {
				return inputWord;
			}

		},
		_APICrudPopup: function (Message, Key) {

			//default config which will get passed if key is null or the wrong key is passed to this function
			let config = sweetalertconfig["DEFAULT"];

			//get the config from sweetalertconfig.js based on the key value
			if (!isNullOrUndefined(Key)) {
				let KeyString = Key.toString().toUpperCase();
				if (!isNullOrUndefined(sweetalertconfig[KeyString])) {
					config = sweetalertconfig[KeyString];
				}
			}
			// console.log("key",key);
			// console.log(config);
			return this.$swal({
				title: "",
				html: 'Communicating with server',
				text: Message,
				type: 'warning',
				allowOutsideClick: false,
				onBeforeOpen: () => {
					this.$swal.showLoading()
				},
			})
		},
		_kendoColumnToUpper(gridId, gridColumnArray) {
			const self = this;
			const grid = $("#" + gridId).data("kendoGrid");
			let data = grid.dataSource.data();
			for (let i = 0; i < gridColumnArray.length; i++) {
				$(data).each(function () {
					this.set(gridColumnArray[i], self._firstLetterToUpper(this.get(gridColumnArray[i])));
				});
			}

		},
		//gridId : 
		//ColumnName:
		//operator eq or neq
		//coulmntext to match
		_disableGridRow(gridId, columnName, operator, columnText) {
			let grid = $("#" + gridId).data("kendoGrid");
			grid.tbody.find('tr').each(function () {
				let dataItem = grid.dataItem(this);
				if (operator == "eq") {
					if (dataItem[columnName].toLowerCase() === columnText.toLowerCase()) {
						$(this).addClass('disableRow');
					} else {
						$(this).removeClass('disableRow');
					}
				} else {
					if (dataItem[columnName].toLowerCase() !== columnText.toLowerCase()) {
						$(this).addClass('disableRow');
					} else {
						$(this).removeClass('disableRow');
					}
				}

			})
		},
		_validateSpecialCharacter(input, type) {
			// eslint-disable-next-line no-useless-escape
			let singleLineRegExp = /[!@#$%^&*_+\=\[\]{};':"\\|<>\/?]+/;
			this.SingleLineSpecialChars = "! @ # $ % ^ & * _ + = / \ ; ' : < > ? " //This is displayed to end user

			// eslint-disable-next-line no-useless-escape
			let multiLineRegExp = /[*_+^\=\[\]{};':"\\|<>\/?]+/;
			// eslint-disable-next-line no-useless-escape
			this.MultiLineSpecialChars = "* _ + ^ = / \ ; ' : < > | ? " //this is displayed to end user

			let emailRegExp = newLocal;

			if (isNullOrUndefined(input)) {
				return false
			} else {
				switch (type) {
					case "singleline":
						return false;
						//return singleLineRegExp.test(input)

					case "multiline":
						return false;
						//return multiLineRegExp.test(input)

					case "email":
						return emailRegExp.test(input)

					default:
						return false;
				}
			}

		},

		//called by kendo date picker on open to set current date as value if value is null
		_setCurrentDateifNull(e) {
			let id = e.sender.element[0].id;
			let value = e.sender._value;
			let todayDate = kendo.toString(kendo.parseDate(new Date()), 'MM/dd/yyyy');
			if (isNullOrUndefined(value) || value == "") {
				let datePicker = $("#" + id).data("kendoDatePicker")
				datePicker.value(todayDate);
				datePicker.trigger("change");
			}

			
		},

		_removeArrayDupes(array){

			
				return array.filter(function (item, index, self) {
					return self.indexOf(item) == index;
				})
			},
		

		// called by excle upload, takes excelcode and formats date
		_getExcelPlatformCode(excelDate) {
            let platformCode = 2
            if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
                platformCode -= 1;
            }
            let localdate = "";
            if (excelDate != null && excelDate != "") {
                excelDate = new Date(
                    Math.round((excelDate - (25567 + platformCode)) * 86400 * 1000)
                )
                let input = excelDate;
                let fmt = "MM/DD/YYYY";
                let zone = "America/New_York";
                // construct a moment object
                let m = moment.tz(input, zone);
                // convert it to utc
                m.utc();
                // format it for output
                localdate = m.format(fmt)

            }
            return localdate;
        },
		_parseJwt(token) {
			let base64Url = token.split('.')[1];
			let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			let jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(jsonPayload);
		},
		_appendDatewithExcelName(fileName){
			let dte = new Date();
 			let time = dte.toTimeString().split(':').join('').substr(0, 4),
        	d = dte.getDate().toString(),
        	m = (dte.getMonth() + 1).toString(),
        	yyyy = dte.getFullYear().toString(),
        	dd = (d.length < 2) ? '0' + d : d,
        	mm = (m.length < 2) ? '0' + m : m,
        	yy = yyyy.substring(2, 4);
			return fileName.substring(0, fileName.lastIndexOf(".")) + mm + dd + yyyy + time + fileName.substring(fileName.lastIndexOf("."));
		}
	}
}


